import { render, staticRenderFns } from "./SentimentByThemes.vue?vue&type=template&id=67559370&scoped=true&"
import script from "./SentimentByThemes.vue?vue&type=script&lang=js&"
export * from "./SentimentByThemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67559370",
  null
  
)

export default component.exports